<template>
	<div :data-to-ignore="true">
		<div class="flex xs-middle mt2">
			<component
				class="xs"
				ref="input"
				:data-to-ignore="true"
				name="value"
				:is="valueComponentName"
				size="xsmall"
				v-model="form.value"
				@blur="saveValue"
			/>
		</div>
		<div :data-to-ignore="true" class="xs-12 mt4 xs-between xs-middle flex">
			<j-button
				v-if="valueComponentName"
				:data-to-ignore="true"
				size="xsmall"
				@click="saveValue"
				:isLoading="isLoading"
				:isDisabled="isLoading"
				>{{ $t("save") }}</j-button
			>
			<j-button
				:data-to-ignore="true"
				v-if="valueComponentName === 'core-monaco-editor'"
				type="tertiary"
				size="xsmall"
				@click="prepopulateDefault"
				>{{ $t("prepopulate_default") }}</j-button
			>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JBaseInputText from "@/components/JBaseInputText"
import JBaseInputNumber from "@/components/JBaseInputNumber"
import CoreMonacoEditor from "@/modules/core/components/CoreMonacoEditor"
import JBaseDatePickerSimple from "@/components/JBaseDatePickerSimple"
import JBaseToggle from "@/components/JBaseToggle"

export default {
	name: "EntityFactUpdate",
	components: {
		JButton,
		JBaseInputText,
		JBaseInputNumber,
		CoreMonacoEditor,
		JBaseDatePickerSimple,
		JBaseToggle
	},
	props: ["value", "entityId", "isLoading"],

	data() {
		return {
			form: {
				value: this.initValue()
			}
		}
	},

	computed: {
		valueComponentName() {
			return this.value.dataType === "number"
				? "j-base-input-number"
				: this.value.dataType === "date"
				? "j-base-date-picker-simple"
				: this.value.dataType === "boolean"
				? "j-base-toggle"
				: this.value.dataType === "string"
				? "j-base-input-text"
				: this.value.dataType === "object"
				? "core-monaco-editor"
				: null
		}
	},

	methods: {
		async saveValue() {
			const valueSubmit = this.parseValue()

			const variables = {
				input: {
					id: this.value.id,
					value: { [this.value.dataType + "Value"]: valueSubmit },
					type: this.value.type
				},
				entityId: this.entityId
			}

			this.$emit("fact:update", variables)
		},

		prepopulateDefault() {
			if (this.value.dataType === "array")
				this.form.value = JSON.stringify([{ stringValue: "" }])
			if (this.value.dataType === "object")
				this.form.value = JSON.stringify([
					{ key: "key", value: { stringValue: "" } }
				])
		},

		initValue() {
			function removeEmpty(obj) {
				return Object.keys(obj).reduce((acc, key) => {
					if (obj[key]) acc[key] = obj[key]
					console.log(acc)
					return acc
				}, {})
			}

			if (this.value.dataType === "object") {
				const formatValue = this.value.value.map(e => ({
					...e,
					value: removeEmpty(e.value)
				}))

				return JSON.stringify(formatValue)
			}

			return this.value.value
		},

		parseValue() {
			if (this.value.dataType === "object" || this.value.dataType === "array") {
				return JSON.parse(this.form.value)
			}
			return this.form.value
		}
	},

	mounted() {
		// Focus on input when mounted
		this.$refs?.input?.$el.focus()
	}
}
</script>
